import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';

import { ChipListCell } from 'core/elements';
import { AgGridFilterOption } from 'core/enums';
import {
  IPricingProfileAccessLocation,
  IPricingProfileAccessRegion,
  IPricingProfileAccessUser,
} from 'pricing/types';

import { ActionsCell, CustomersCell } from './cells';

interface IColumnDefParams {
  isEditable?: boolean;
}

export const getColumnDef = ({ isEditable = true }: IColumnDefParams = {}): ColDef[] => [
  {
    colId: 'actions',
    width: 80,
    maxWidth: 80,
    sortable: false,
    resizable: false,
    cellRenderer: ActionsCell,
    cellRendererParams: {
      isEditable,
    },
    suppressColumnsToolPanel: true,
    pinned: 'left',
    lockPinned: true,
  },
  {
    colId: 'customers',
    field: 'customers',
    headerName: t('headerCustomers'),
    cellRenderer: CustomersCell,
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: [
        AgGridFilterOption.CONTAINS,
        AgGridFilterOption.NOT_CONTAINS,
        AgGridFilterOption.BLANK,
        AgGridFilterOption.NOT_BLANK,
      ],
    },
    sortable: true,
    flex: 3,
    minWidth: 300,
  },
  {
    colId: 'users',
    field: 'users',
    headerName: t('headerUsers'),
    cellRenderer: ChipListCell,
    cellRendererParams: {
      getChipValue: (user: IPricingProfileAccessUser) => user.corporateUserName,
      placeholder: t('labelAll'),
    },
    filter: 'agTextColumnFilter',
    sortable: true,
    flex: 2,
    minWidth: 200,
  },
  {
    colId: 'locations',
    field: 'locations',
    headerName: t('headerLocations'),
    cellRenderer: ChipListCell,
    cellRendererParams: {
      getChipValue: (location: IPricingProfileAccessLocation) =>
        location.corporateLocationAddressName,
      placeholder: t('labelAll'),
    },

    filter: 'agTextColumnFilter',
    sortable: true,
    flex: 2,
    minWidth: 150,
  },
  {
    colId: 'regions',
    field: 'regions',
    headerName: t('headerRegions'),
    cellRenderer: ChipListCell,
    cellRendererParams: {
      getChipValue: (region: IPricingProfileAccessRegion) => region.corporateRegionName,
      placeholder: t('labelAll'),
    },
    filter: 'agTextColumnFilter',
    sortable: true,
    flex: 2,
    minWidth: 150,
  },
];
